import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form'
import { Flex, Heading, FormErrorMessage,  FormLabel,  FormControl,  Input,  Button, Box, Stack } from '@chakra-ui/react';
import FieldGroupItem from '../FieldGroupItem';

type Props = {
  fieldGroups: any[];
  onUpdateFieldGroups: (fieldGroups: any[]) => void;
};

function FieldGroups({ fieldGroups, onUpdateFieldGroups }: Props) {
  const [fieldGroupsLocal, setFieldGroupsLocal] = useState(fieldGroups);
  
  const addFieldGroup = () => {		
    setFieldGroupsLocal([
      ...fieldGroupsLocal,
      {
        id: '',
        title: '',
        fields: [],
        layout: 'vertical'
      }
    ]);
  }

  const onUpdateFieldGroupItem = (item:any, index:number) => {		
    let newFieldGroups = [...fieldGroupsLocal];
    newFieldGroups[index] = item;
    setFieldGroupsLocal(newFieldGroups);
  }

  useEffect(() => {
    onUpdateFieldGroups(fieldGroupsLocal);
  }, [fieldGroupsLocal])

  // useEffect(() => {
  //   setFieldGroupsLocal(fieldGroups);
  // }, [fieldGroups])

  return (
    <>
    <Box pb="5">
      <Heading size="md" pb="4">필드 그룹 목록</Heading>
      <Stack>
        {
          fieldGroupsLocal.map((item:any, index:number) => (
            <FieldGroupItem key={index} item={item} list={fieldGroupsLocal} index={index} onUpdateFieldGroupItem={onUpdateFieldGroupItem} />
          ))
        }
      </Stack>
    </Box>
    <Box textAlign="right">
      <Button variant='outline' size="md" type='button' colorScheme="g" onClick={addFieldGroup}> 
        필드 그룹 추가
      </Button>
    </Box>
    </>
  );
}

FieldGroups.defaultProps = {
};

export default FieldGroups;